import { z } from 'zod'

export const OnboardingSurveyRequestSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  area_of_practice: z.string(),
  professional_role: z.string(),
  firm_size: z.string(),
  planned_use_first_choice: z.string(),
  planned_use_second_choice: z.string().optional(),
  planned_use_third_choice: z.string().optional(),
  paxton_referrer: z.string(),
  social_media_source: z.string().optional(),
})

export const OnboardingSurveyResponseSchema = z.object({
  success: z.boolean().optional(),
})

export type OnboardingSurveyRequest = z.infer<typeof OnboardingSurveyRequestSchema>
export type OnboardingSurveyResponse = z.infer<typeof OnboardingSurveyResponseSchema>
